import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  //Vulnerability Type Strict transport security not enforced
  const win: any = window;
  if (win) {
    win.location.href.startsWith('https://') && win.location.replace('https://' + win.location.href.substr(8));
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

